<div class="modal-header">
  <h5 class="modal-title">Verify PD Hours</h5>
</div>
<div class="modal-body">
  <form #awardForm="ngForm">
    <div class="mb-3">
      <label class="form-label fw-semibold" for="description">Description</label>
      <input
        type="text"
        id="description"
        #description="ngModel"
        class="form-control"
        placeholder="e.g. Online Teaching Course"
        [(ngModel)]="verifyRemainingProfessionalDevelopmentHoursCommand.description"
        name="description"
      />
    </div>
    <div validationErrors [for]="description.control" [errorEmitter]="errorEmitter" class="mb-3"></div>

    <div class="mb-3">
      <label class="form-label fw-semibold">Completion Date</label>
      <cert-date-input
        name="completionDate"
        [(model)]="verifyRemainingProfessionalDevelopmentHoursCommand.completionDate"
        [propertyName]="'completionDate'"
      />
    </div>
    <div formLevelValidationErrors [for]="awardForm" [errorEmitter]="errorEmitter" class="mb-3"></div>

    <div class="mb-3">
      <label for="professionalDevelopmentTypeCodeId" class="form-label">Professional Development Type</label>
      <ng-select
        id="professionalDevelopmentTypeCodeId"
        name="professionalDevelopmentTypeCodeId"
        [closeOnSelect]="true"
        [multiple]="false"
        #professionalDevelopmentTypeCodeId="ngModel"
        [(ngModel)]="verifyRemainingProfessionalDevelopmentHoursCommand.professionalDevelopmentTypeCodeId"
        placeholder="Select a type..."
      >
        @for (option of professionalDevelopmentTypeOptions; track $index) {
          <ng-option [value]="option.id">{{ option.description }}</ng-option>
        }
      </ng-select>
      <div
        validationErrors
        [for]="professionalDevelopmentTypeCodeId.control"
        [errorEmitter]="errorEmitter"
        class="mb-3"
      ></div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="dismiss()" [disabled]="submitting()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="submitting()">
    @if (submitting()) {
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    }
    {{ submitting() ? 'Verifying...' : 'Verify' }}
  </button>
</div>
